import { createSlice } from "@reduxjs/toolkit";
import { 
    fetchReportingStats, 
    fetchTranscriptsAverageCountHourly, 
    fetchTranscriptsCountDaily,
    fetchWeeklyActivity,
    fetchChatRatingReport,
    fetchSchedulingReport,
    sendDigestReportEmail 
} from "./reportingAPI";
// import moment from "moment";
import { momentCustomInstance as moment } from '../../app/common/libs/helper';
import { getHoursDataWithLabels } from '../../app/common/libs/helper'

export const initialState = {
  startDate: moment().subtract(29, 'days').format(),
  endDate: moment().format(),
  overAllChatRatings: {},
  categoryChatRatings: [
    { categoryName: 'Responsive', ratingValues: [] },
    { categoryName: 'Knowledge', ratingValues: [] },
    { categoryName: 'Satisfy', ratingValues: [] },
    { categoryName: 'Friendly', ratingValues: [] },
  ],
  transcriptsHourlyAverageCountStats: { hourlyChat: [], hourlyOfflineMessage: [] },
  transcriptsDailyCountStats: {
    totalChats: 0,
    averageChatsPerDay: 0,
    totalOfflineMessages: 0,
    averageOfflineMessagesPerDay: 0,
    dates: [],
  },
  weeklyActivity: {
    onlineAgents: [],
    mostAvailableAgent: {
        id: "",
        name: "",
        email: "",
        isOnline: false,
        AvailableHours: 0,
        ChatCount: 0,
        AvgRatingValue: 0,
        AvgResponseTime: 0
    },
    leastAvailableAgent: {
        id: "",
        name: "",
        email: "",
        isOnline: false,
        AvailableHours: 0,
        ChatCount: 0,
        AvgRatingValue: 0,
        AvgResponseTime: 0
    },
    totalChatTaken: 0,
    previousWeekChatTaken: 0,
    previousWeekChatGreaterThanCurrent: false,
    medianDurationOfChat: 0,
    previousWeekMedianDurationOfChat: 0,
    previousWeekMedianDurationGreater: false
  },
  chatRatingReport: {
    agentsAvgRatingCount: 0,
    previousWeekAvgRatingCount: 0,
    previousWeekAgentAvgRatingGreaterThanCurrent: false,
    goodChats: 0,
    chatToReview: 0
  },
  schedulingReport: {
    totalOfflineMsgsCount: 0,
    totalChatsCount: 0,
    mostOfflineMessages: {
        day: "",
        dayCount: 0,
        hour: "",
        hourCount: 0
    },
    mostChats: {
        day: "",
        dayCount: 0,
        hour: "",
        hourCount: 0
    }
  },
  aboveFour: 0,
  bellowFour: 0,
  reportPeriod: "Weekly",
  loading: false,
  activityLoading: false,
  ratingLoading: false,
  schedulingLoading: false,
  error: null,
};

export const reportingSlice = createSlice({
    name: 'reporting',
    initialState: initialState,
    reducers: {
        setDate: (state, action) => {
            state.startDate = action.payload.start;
            state.endDate = action.payload.end;
        },
        setReportPeriod: (state, action) => {
            state.reportPeriod = action.payload;
        }
    },
    extraReducers: {
        [fetchReportingStats.pending]: (state) => {
            console.log('fetchReportingStats.pending')
            state.loading = true;
            state.error = '';
        },
        [fetchReportingStats.rejected]: (state, {meta, error}) => {
            console.log('fetchReportingStats.rejected')
            state.loading = false;
            state.error = error;
        },
        [fetchReportingStats.fulfilled]: (state,  { meta, payload: { data } }) => {
            console.log('fetchReportingStats.fulfilled')
            state.loading = false;
            state.error = '';
            state.categoryChatRatings = data.chatRatings.filter(a => a.categoryName !== 'OverAll');;
            
            let overAllRatings = data.chatRatings.find(a => a.categoryName == 'OverAll');
            state.overAllChatRatings = overAllRatings;

            // Make sure to reset values
            state.bellowFour = state.aboveFour = 0;
            // re-calculate values
            overAllRatings.ratingValues.forEach((v, i) => {
              i < 3 ? (state.bellowFour += v) : (state.aboveFour += v);
            });

            console.log('==overAllChatRatings==', overAllRatings);
            console.log('==bellowFour and aboveFour==', state.bellowFour, state.aboveFour);
        },
        [fetchTranscriptsAverageCountHourly.pending]: (state) => {
            console.log('fetchTranscriptsAverageCountHourly.pending')
            state.loading = true;
            state.error = '';
        },
        [fetchTranscriptsAverageCountHourly.rejected]: (state, {meta, error}) => {
            console.log('fetchTranscriptsAverageCountHourly.rejected')
            state.loading = false;
            state.error = error;
        },
        [fetchTranscriptsAverageCountHourly.fulfilled]: (state,  { meta, payload: { data } }) => {
            console.log('fetchTranscriptsAverageCountHourly.fulfilled')
            console.log('hourlyOfflineMessage :>> ', data);
            state.loading = false;
            state.error = '';
            state.transcriptsHourlyAverageCountStats.hourlyChat = getHoursDataWithLabels(data?.hourlyChat);
            state.transcriptsHourlyAverageCountStats.hourlyOfflineMessage = getHoursDataWithLabels(data?.hourlyOfflineMessage);
        },
        [fetchTranscriptsCountDaily.pending]: (state) => {
            console.log('fetchTranscriptsCountDaily.pending')
            state.loading = true;
            state.error = '';
        },
        [fetchTranscriptsCountDaily.rejected]: (state, {meta, error}) => {
            console.log('fetchTranscriptsCountDaily.rejected')
            state.loading = false;
            state.error = error;
        },
        [fetchTranscriptsCountDaily.fulfilled]: (state,  { meta, payload: { data } }) => {
            console.log('fetchTranscriptsCountDaily.fulfilled')
            console.log('hourlyOfflineMessage :>> ', data);
            state.loading = false;
            state.error = '';
            state.transcriptsDailyCountStats = data;
        },
        [fetchWeeklyActivity.pending]: (state) => {
            console.log('fetchWeeklyActivity.pending')
            state.activityLoading = true;
            state.error = '';
        },
        [fetchWeeklyActivity.rejected]: (state, {meta, error}) => {
            console.log('fetchWeeklyActivity.rejected')
            state.activityLoading = false;
            state.error = error;
        },
        [fetchWeeklyActivity.fulfilled]: (state,  { meta, payload: { data } }) => {
            console.log('fetchWeeklyActivity.fulfilled')
            state.activityLoading = false;
            state.error = '';
            
            state.weeklyActivity.onlineAgents = data.onlineAgents != null && data.onlineAgents.length > 0 ? data.onlineAgents : [];
            if(data.mostAvailableAgent != null) {
                state.weeklyActivity.mostAvailableAgent = data.mostAvailableAgent; 
            }
            else {
                state.weeklyActivity.mostAvailableAgent = {
                    id: "",
                    name: "",
                    email: "",
                    isOnline: false,
                    AvailableHours: 0,
                    ChatCount: 0,
                    AvgRatingValue: 0,
                    AvgResponseTime: 0
                }
            }
            if(data.leastAvailableAgent != null) {
                state.weeklyActivity.leastAvailableAgent = data.leastAvailableAgent; 
            }
            else {
                state.weeklyActivity.leastAvailableAgent = {
                    id: "",
                    name: "",
                    email: "",
                    isOnline: false,
                    AvailableHours: 0,
                    ChatCount: 0,
                    AvgRatingValue: 0,
                    AvgResponseTime: 0
                }
            }
            state.weeklyActivity.totalChatTaken = data.totalChatTaken ? data.totalChatTaken : 0;
            state.weeklyActivity.previousWeekChatTaken = data.previousWeekChatTaken ? data.previousWeekChatTaken : 0;
            state.weeklyActivity.previousWeekChatGreaterThanCurrent = data.previousWeekChatGreaterThanCurrent;
            state.weeklyActivity.medianDurationOfChat = data.medianDurationOfChat ? data.medianDurationOfChat : 0;
            state.weeklyActivity.previousWeekMedianDurationOfChat = data.previousWeekMedianDurationOfChat ? data.previousWeekMedianDurationOfChat : 0;
            state.weeklyActivity.previousWeekMedianDurationGreater = data.previousWeekMedianDurationGreater;
            
        },
        [fetchChatRatingReport.pending]: (state) => {
            console.log('fetchChatRatingReport.pending')
            state.ratingLoading = true;
            state.error = '';
        },
        [fetchChatRatingReport.rejected]: (state, {meta, error}) => {
            console.log('fetchChatRatingReport.rejected')
            state.ratingLoading = false;
            state.error = error;
        },
        [fetchChatRatingReport.fulfilled]: (state,  { meta, payload: { data } }) => {
            console.log('fetchChatRatingReport.fulfilled')
            state.ratingLoading = false;
            state.error = '';
            state.chatRatingReport.agentsAvgRatingCount = data.agentsAvgRatingCount ? data.agentsAvgRatingCount : 0;
            state.chatRatingReport.previousWeekAvgRatingCount = data.previousWeekAvgRatingCount ? data.previousWeekAvgRatingCount : 0;
            state.chatRatingReport.previousWeekAgentAvgRatingGreaterThanCurrent = data.previousWeekAgentAvgRatingGreaterThanCurrent;
            state.chatRatingReport.goodChats = data.goodChats ? data.goodChats : 0;
            state.chatRatingReport.chatToReview = data.chatToReview ? data.chatToReview : 0;
        },
        [fetchSchedulingReport.pending]: (state) => {
            console.log('fetchSchedulingReport.pending')
            state.schedulingLoading = true;
            state.error = '';
        },
        [fetchSchedulingReport.rejected]: (state, {meta, error}) => {
            console.log('fetchSchedulingReport.rejected')
            state.schedulingLoading = false;
            state.error = error;
        },
        [fetchSchedulingReport.fulfilled]: (state,  { meta, payload: { data } }) => {
            console.log('fetchSchedulingReport.fulfilled')
            state.schedulingLoading = false;
            state.error = '';

            state.schedulingReport.totalOfflineMsgsCount = data.totalOfflineMsgsCount ? data.totalOfflineMsgsCount : 0;
            state.schedulingReport.totalChatsCount = data.totalChatsCount ? data.totalChatsCount : 0;
            if(data.mostOfflineMessages != null) {
                state.schedulingReport.mostOfflineMessages = data.mostOfflineMessages;  
            }
            else {
                state.schedulingReport.mostOfflineMessages = {
                    day: "",
                    dayCount: 0,
                    hour: "",
                    hourCount: 0
                }
            }

            if(data.mostChats != null) {
                state.schedulingReport.mostChats = data.mostChats;  
            }
            else {
                state.schedulingReport.mostChats = {
                    day: "",
                    dayCount: 0,
                    hour: "",
                    hourCount: 0
                }
            }
            state.schedulingReport = data;
        },
        [sendDigestReportEmail.pending]: (state) => {
            console.log('fetchSchedulingReport.pending')
            state.loading = true;
            state.error = '';
        },
        [sendDigestReportEmail.rejected]: (state, {meta, error}) => {
            console.log('fetchSchedulingReport.rejected')
            state.loading = false;
            state.error = error;
        },
        [sendDigestReportEmail.fulfilled]: (state,  { meta, payload: { data } }) => {
            console.log('sendDigestReportEmail.fulfilled')
            state.loading = false;
            state.error = '';
        },
    }
});

export const { setDate, setReportPeriod } = reportingSlice.actions;
export default reportingSlice.reducer;
